import { render, staticRenderFns } from "./DialogPrice.vue?vue&type=template&id=4c00aea1"
import script from "./DialogPrice.vue?vue&type=script&lang=js"
export * from "./DialogPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c00aea1')) {
      api.createRecord('4c00aea1', component.options)
    } else {
      api.reload('4c00aea1', component.options)
    }
    module.hot.accept("./DialogPrice.vue?vue&type=template&id=4c00aea1", function () {
      api.rerender('4c00aea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/dishesManagement/components/DialogPrice.vue"
export default component.exports